import { connect } from 'react-redux';

import Preview from 'carbon-react/lib/components/preview';

const PreviewComponent = () => {
  return (
    <div className="privacy">
      <Preview lines={24} loading />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataSources: state.dataSources,
});

export default connect(mapStateToProps, null)(PreviewComponent);
